// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__clfHy","title":"Images45_title__3RdaN","images":"Images45_images__Lp-KX"};